export class CompaniesMiniEntity {
  id?: number
  name?: string
  logoUrl?: string | null
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  disabled?: boolean
}
